import { render, staticRenderFns } from "./CampaignStatus.vue?vue&type=template&id=a22e5d3a&scoped=true&"
import script from "./CampaignStatus.vue?vue&type=script&lang=js&"
export * from "./CampaignStatus.vue?vue&type=script&lang=js&"
import style0 from "./CampaignStatus.vue?vue&type=style&index=0&id=a22e5d3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22e5d3a",
  null
  
)

export default component.exports